import { default as BaseButton } from "@mui/material/Button";

export type ButtonProps = React.ComponentProps<typeof BaseButton>;

export default function Button(props: ButtonProps) {
	return (
		<BaseButton
			style={{ textTransform: "none", fontWeight: 600, borderRadius: 10 }}
			{...props}
		/>
	);
}
